import { propertyAreaUnitService } from '@/services/api/propertyAreaUnit.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { propertyAreaUnitModel } from '@/models/api/propertyAreaUnit.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PROPERTY_AREA_UNIT_MODULE = "api/propertyAreaUnit";

// ACTIONS
export const GET_ALL_PROPERTY_AREA_UNIT = 'getAllPropertyAreaUnit';
export const CREATE_PROPERTY_AREA_UNIT = 'createPropertyAreaUnit';
export const GET_PROPERTY_AREA_UNIT = 'getPropertyAreaUnit';
export const UPDATE_PROPERTY_AREA_UNIT = 'updatePropertyAreaUnit';
export const UPDATE_PROPERTY_AREA_UNIT_STATUS = 'updatePropertyAreaUnitStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PROPERTY_AREA_UNIT_SUCCESS = "allPropertyAreaUnitSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PROPERTY_AREA_UNIT_SUCCESS = "getPropertyAreaUnitSuccess";

export const actions = {
    [GET_ALL_PROPERTY_AREA_UNIT]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        propertyAreaUnitService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PROPERTY_AREA_UNIT_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PROPERTY_AREA_UNIT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyAreaUnitService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_AREA_UNIT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PROPERTY_AREA_UNIT]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return propertyAreaUnitService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PROPERTY_AREA_UNIT_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_AREA_UNIT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyAreaUnitService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_AREA_UNIT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PROPERTY_AREA_UNIT_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return propertyAreaUnitService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_AREA_UNIT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PROPERTY_AREA_UNIT_SUCCESS](state, {data}) {
        let propertyAreaUnitList = data.data || [];
        state.list.data = propertyAreaUnitList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = propertyAreaUnitList.map(item => propertyAreaUnitModel(item));
        }
    },
    [GET_PROPERTY_AREA_UNIT_SUCCESS](state, data) {
        state.details = propertyAreaUnitModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
